<template>
  <modal :closeModal="closeModal">
    <component v-bind:is=modalComponent :callback=modalCallback :target=target />
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"

export default {
  components: {
    Modal
  },
  props: {
    closeModal: {
      type: Function,
      default: function () {
        return {}
      }
    },
    kind: {
      type: String,
      default: function () {
        return undefined
      }
    },
    modals: {
      type: Object,
      default: function () {
        return {}
      }
    },
    target: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    modalComponent: function () {
      return this.modals[this.kind].component
    },
    modalCallback: function () {
      return this.modals[this.kind].callback
    }
  }
}
</script>
